/**
 * [INPUT]: 依赖 clsx 的条件类展开与 tailwind-merge 的 Tailwind 冲突消解
 * [OUTPUT]: 对外提供 cn(...inputs) 类名合并函数
 * [POS]: zinnercms-design-system/lib 的唯一 className 组合底座，被全部 UI primitive 与 pattern 消费
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
